import React from 'react';
import { translate } from 'react-i18next';

import { Form } from 'common/components';

const CatalogsListFilters = ({
  handleSubmit = () => {},
  handleValueChange = () => {},
  handleToggleSearch = () => {}, // Agregar
  columnSearch,
  t,
  values = {},
}) => {
  return (
    <form
      onSubmit={(e) => {
        e && e.preventDefault();
        handleSubmit();
      }}
      noValidate
      autoComplete="false"
    >
      {/* <div className="row mt-3"> */}
      <div className="col-sm-6 col-lg-12 d-flex flex-row">
        {/* ColumnSearch */}
        <div className="dropdown mr-3">
          <button
            className="btn btn-secondary dropdown-toggle"
            type="button"
            id="dropdownMenuButton"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            {t('actions.selectSearch')}
          </button>
          <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
            {columnSearch.map((column) => {
              return (
                <div className="dropdown-item form-check form-check-inline">
                  <input
                    type="checkbox"
                    checked={column.search}
                    class="form-check-input"
                    onClick={(e) => {
                      handleToggleSearch(column.key);
                    }}
                  />
                  <label
                    className="form-check-label"
                    onClick={(e) => {
                      e && e.preventDefault();
                      handleToggleSearch(column.key);
                    }}
                  >
                    {column.name}
                  </label>
                </div>
              );
            })}
          </div>
        </div>
        {/* ColumnSearch */}
        <Form.FieldInput
          autoFocus={true}
          name={'fulltext'}
          placeholder={t('actions.search')}
          handleChange={handleValueChange}
          iconRight="search"
          t={t}
          value={values.fulltext}
          extraClassName="icon-right"
        />
      </div>
      {/* </div> */}
    </form>
  );
};

export default translate()(CatalogsListFilters);



// WEBPACK FOOTER //
// src/modules/secured/modules/catalogs/components/list/CatalogsListFilters.js